import React, { useState } from "react";
import "../Css/footer.css";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../image/career_sahi_logo.png";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import insta from '../image/black_instagram.png';
import linked from '../image/black_linkedin.png';
import wp from '../image/black_whatsapp.png';
import face from '../image/black_facebook.png';
import { faC } from "@fortawesome/free-solid-svg-icons";
const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(location.pathname);

  const handleNavigation = (path) => {
    setActiveTab(path);  // Update active tab
    navigate(path);       // Navigate to the selected page
  };
  return (
    // <footer className="">
    //   <div className="container d-flex justify-content-evenly g-40">
    //     <div className="left col-5 mb-3">
    //       <div className="logo">
    //         <img src={logo} className="mb-4" alt="main-logo" />
    //       </div>
    //       <p>
    //         કરિયરસહી એ વિદ્યાર્થીનું કરિયર ખરા અર્થમાં સહી થઇ શકે આ હેતુથી ચાલુ
    //         કરવામાં આવેલ એક પહેલ છે.
    //       </p>
    //       <p>
    //         જેમાં કારકિર્દીની પસંદગીથી લઈને કારકિર્દીને સફળ બનાવવા સુધીની સફરમાં
    //         કરિયરસહી દરેક પગલે સાથે છે.
    //       </p>

    //       <div className="d-flex">
    //         <a href="https://www.instagram.com/careersahi/" target="_blank"  rel="noreferrer">
    //           <img src={insta} className="" alt="instagramicon" />
    //         </a>
    //         <a href="https://www.linkedin.com/company/careersahi/" target="_blank"  rel="noreferrer">
    //           <img src={linked} className="" alt="linkedinicon" />
    //         </a>
    //         <a href="https://api.whatsapp.com/send/?phone=8238235437&text=Hello&type=phone_number&app_absent=0" target="_blank"  rel="noreferrer">
    //           <img src={wp} className="" alt="whatsappicon" />
    //         </a>
    //         <a href="https://www.facebook.com/careersahiofficial" target="_blank"  rel="noreferrer">
    //           <img src={face} className="" alt="facebookicon" />
    //         </a>
    //       </div>
    //     </div>
    //     <div className="right col-5">
    //       <h6 className="mb-4 fw-bold">
    //         સલાહ વહી, જો હો સહી...
    //       </h6>

    //       <h6 className="fw-bold">
    //         ઓફિસ એડ્રેસ
    //       </h6>
    //       <p>
    //         601, પવિત્રા પોઇન્ટ, સાવલિયા સર્કલ પાસે, યોગીચોક-વનમાળી રોડ, સુરત
    //       </p>

    //       <h6 className="fw-bold">
    //         અપોઈન્ટમેન્ટ માટે કોલ કરો
    //       </h6>
    //       <p>+91 82382 35437</p>

    //       <h6 className="fw-bold">
    //         હેલ્પલાઇન નંબર
    //       </h6>
    //       <p>+91 82382 35437</p>
    //     </div>
    //   </div>
    //   <hr />
    //   <p className="text-center">
    //     Copyright © 2024 DwarkeshSoft Private Limited - All rights reserved.
    //   </p>
    // </footer>

    // ----------------------------------------Footer------------------------------------
    <footer>
      <br />
      <Container fluid>
        <Row className="justify-content-center">
          {/* ----------------------------- */}
          <Col className="mt-sm-4 mt-2" xl="10" xxl="9">
            <Row className="justify-content-center">
              <Col xl="9" className="h-100">
                <Row className="d-flex flex-column align-items-center">
                  <div className="">
                    <div className="row">
                      <div className="col-lg-4 col-md-4 col-sm-5 col-5 footer-column">
                        <h4 className="fw-semibold pb-2">Quick Links</h4>
                        <ul className="pointer">
                          <li
                            className={activeTab === "/testimonials" ? "active" : ""}
                            onClick={() => handleNavigation("/testimonials")}
                          >
                            Testimonials
                          </li>
                          <li
                            className={activeTab === "/pricing" ? "active" : ""}
                            onClick={() => handleNavigation("/pricing")}
                          >
                            Pricing
                          </li>
                          <li
                            className={activeTab === "/contact" ? "active" : ""}
                            onClick={() => handleNavigation("/contact")}
                          >
                            Contact Us
                          </li>
                        </ul>
                      </div>

                      <div className="col-lg-4 col-md-4 col-sm-5 col-7 footer-column">
                        <h4 className="fw-semibold pb-2">Partnerships</h4>
                        <ul>
                          <li><Link>Corporate - CSR (Soon)</Link></li>
                          <li><Link>Private Schools (Soon)</Link></li>
                          <li><Link>Counsellor</Link></li>
                        </ul>
                      </div>

                      <div className="col-lg-4 col-md-4 col-sm-5 footer-column">
                        <h4 className="fw-semibold pb-2">Legal</h4>
                        <ul>
                          <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                          <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                          <li><Link to="/refund-policy">Refund Policy</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="d-xl-block d-none ">
                  <div className="d-flex  mt-xl-4 mt-0 mb-3 mb-lg-0 align-self-center">
                    {/* Right Side: Social Media Links */}
                  <div className="py-4  col-3 px-0 pt-3  follow_btns">
                    <h6 className="fw-semibold pb-2">Let's be Friends</h6>
                    <a href="https://www.instagram.com/careersahi/" target="_blank" rel="noopener noreferrer">
                      <img src={insta} alt="Instagram" />
                    </a>
                    <a href="https://www.linkedin.com/company/careersahi/" target="_blank" rel="noopener noreferrer">
                      <img src={linked} alt="LinkedIn" />
                    </a>
                    <a href="https://wa.me/8238235437?text=Hello CareerSahi" target="_blank" rel="noopener noreferrer">
                      <img src={wp} alt="WhatsApp" />
                    </a>
                    <a href="https://www.facebook.com/careersahiofficial" target="_blank" rel="noopener noreferrer">
                      <img src={face} alt="Facebook" />
                    </a>
                  </div>
                  <div className="text-center col-6">
                    <img alt="logo" src={logo} className="col-xl-7 col-lg-5 col-md-5 col-10" />
                  </div>
                  </div>
                  </div>
                </Row>
              </Col>
              <Col className="h-100" xl="3">
                <Row>
                  <div className="col-12 footer-column">
                    <h4 className="fw-semibold pb-2">Operational Office Address</h4>
                    <div>
                      <p>601, Pavitraa Point, Near Savaliya Circle, Yogichowk, Surat - 395010</p>
                    </div>
                    <div>
                      <h6 className="fw-semibold">Write to Us</h6>
                      <p>
                      <Link to="mailto:info@careersahi.com" className="text-decoration-none pointer text-black">
                        info@careersahi.com
                      </Link>
                      </p>
                    </div>
                    <div>
                      <h6 className="fw-semibold">Call Our Helpline</h6>
                      <p><Link className="pointer text-black" to={"tel:+91-8238235437"}>+91 82382 35437</Link></p>
                    </div>
                    <div>
                      <h6 className="fw-semibold">Timings</h6>
                      <p>10:00 AM - 6:00 PM</p>
                    </div>
                  </div>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col xl="10" xxl="9">
            <div className="copy_write">
              <div className="">
                <div className="row align-items-center m-0">
                  {/* Right Side: Social Media Links */}
                  <div className="col-lg-3 pb-3 py-xl-4 pt-2 px-0 d-xl-none d-block follow_btns">
                    <h6 className="fw-semibold  pb-xl-2">Let's be Friends</h6>
                    <a href="https://www.instagram.com/careersahi/" target="_blank" rel="noopener noreferrer">
                      <img src={insta} alt="Instagram" />
                    </a>
                    <a href="https://www.linkedin.com/company/careersahi/" target="_blank" rel="noopener noreferrer">
                      <img src={linked} alt="LinkedIn" />
                    </a>
                    <a href="https://wa.me/8238235437?text=Hello CareerSahi" target="_blank" rel="noopener noreferrer">
                      <img src={wp} alt="WhatsApp" />
                    </a>
                    <a href="https://www.facebook.com/careersahiofficial" target="_blank" rel="noopener noreferrer">
                      <img src={face} alt="Facebook" />
                    </a>
                  </div>
                      {/* Left Side: Copyright & Policies */}
                  <div className="important_link_f px-5 px-sm-0 border-top pt-3 pb-3 text-center d-flex flex-sm-nowrap justify-content-center   flex-wrap col-lg-12">
                    <h6 style={{fontSize:'14px'}} className="fw-bold mb-0"><b> CareerSahi Edtech Private Limited. </b></h6> {" "}
                    <h6 style={{fontSize:'14px'}} className="align-self-center ps-2">{" "} All Rights Reserved</h6>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
